<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('抽奖活动奖池配置.名称')" prop="name">
                <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('抽奖活动奖池配置.名称')" allow-clear/>
              </a-form-item>
            </a-col>


            <!--<a-col :md="6" :sm="24">-->
              <!--<a-form-item :label="$t('抽奖活动奖池配置.图片')" prop="picture">-->
                <!--<a-input v-model="queryParam.picture" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('抽奖活动奖池配置.图片')" allow-clear/>-->
              <!--</a-form-item>-->
            <!--</a-col>-->


            <!--<template v-if="advanced">-->
              <!--<a-col :md="6" :sm="24">-->
                <!--<a-form-item :label="$t('抽奖活动奖池配置.奖励金额')" prop="gold">-->
                  <!--<a-input v-model="queryParam.gold" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('抽奖活动奖池配置.奖励金额')" allow-clear/>-->
                <!--</a-form-item>-->
              <!--</a-col>-->
            <!--</template>-->
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <!--<a @click="toggleAdvanced" style="margin-left: 8px">-->
                  <!--{{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}-->
                  <!--<a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--</a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--<a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['luckActivity:luckActivity:add']">-->
          <!--<a-icon type="plus" />{{$t('通用.按钮.新增')}}-->
        <!--</a-button>-->
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['luckActivity:luckActivity:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button>
        <!--<a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['luckActivity:luckActivity:remove']">-->
          <!--<a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
        <!--</a-button>-->
        <a-button type="primary" @click="handleExport" v-hasPermi="['luckActivity:luckActivity:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >

         <span slot="type" slot-scope="text, record">
           <!--<custom-dict-tag :options="customDict.SECKILLENUM" :value="record.checkStatus"/>-->
           <span v-if="record.type == '1'">
             {{$t('奖励类型.谢谢惠顾')}}
           </span>
           <span v-if="record.type == '2'">
             {{$t('代币')}}
           </span>
           <span v-if="record.type == '3'">
             {{$t('奖励类型.商品')}}
           </span>
            <span v-if="record.type == '4'">
             {{$t('奖励类型.优惠券')}}
           </span>
        </span>

        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
          </div>
        </template>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!--<a-divider type="vertical" v-hasPermi="['luckActivity:luckActivity:edit']" />-->
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['luckActivity:luckActivity:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <!--<a-divider type="vertical" v-hasPermi="['luckActivity:luckActivity:remove']" />-->
          <!--<a @click="handleDelete(record)" v-hasPermi="['luckActivity:luckActivity:remove']">-->
            <!--<a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
          <!--</a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageLuckActivity,listLuckActivity, delLuckActivity } from '@/api/luckActivity/luckActivity'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'LuckActivity',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: undefined,
        picture: undefined,
        type: undefined,
        gold: undefined,
        description: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: this.$t('抽奖活动奖池配置.id'),
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('抽奖活动奖池配置.名称'),
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('抽奖活动奖池配置.图片'),
          dataIndex: 'picture',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('抽奖活动奖池配置.奖励类型'),
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'type'},
        },
        {
          title: this.$t('抽奖活动奖池配置.奖励金额'),
          dataIndex: 'gold',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('抽奖活动奖池配置.中奖概率'),
          dataIndex: 'probability',
          ellipsis: true,
          align: 'center',
          customRender: (text) => text != null ? text + '%' : '-'
        },
        {
          title: this.$t('抽奖活动奖池配置.排序'),
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('抽奖活动奖池配置.描述'),
        //   dataIndex: 'description',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('抽奖活动奖池配置.创建时间'),
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('抽奖活动奖池配置.备注'),
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询抽奖活动奖池配置列表 */
    getList () {
      this.loading = true
     pageLuckActivity(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        picture: undefined,
        type: undefined,
        gold: undefined,
        description: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delLuckActivity(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('luckActivity/luckActivity/export',
            ...that.queryParam
          , `抽奖活动奖池配置_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
